module.exports = __webpack_public_path__ + "hubspot-3-08cc20389528e0a7c20a4cd7a34305e4.webp";